import * as RadixTabs from '@radix-ui/react-tabs';
import { styled } from 'styled-components';

export const TrueFalseTabs = ({
  trueTabChildren,
  falseTabChildren,
}: {
  trueTabChildren?: React.ReactNode;
  falseTabChildren?: React.ReactNode;
}) => (
  <Container>
    <RadixTabs.Root className="TabsRoot" defaultValue="tabTrue">
      <RadixTabs.List className="TabsList" aria-label="Manage your account">
        <RadixTabs.Trigger className="TabsTrigger" value="tabTrue">
          True
        </RadixTabs.Trigger>
        <RadixTabs.Trigger className="TabsTrigger" value="tabFalse">
          False
        </RadixTabs.Trigger>
      </RadixTabs.List>

      <RadixTabs.Content className="TabsContent" value="tabTrue">
        {trueTabChildren}
      </RadixTabs.Content>

      <RadixTabs.Content className="TabsContent" value="tabFalse">
        {falseTabChildren}
      </RadixTabs.Content>
    </RadixTabs.Root>
  </Container>
);

const Container = styled.div`
  .TabsList {
    flex-shrink: 0;
    display: flex;
    border-bottom: 1px solid transparent;
  }

  .TabsTrigger {
    height: 30px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    color: var(--text-color-secondary);
    font-size: 13px;

    transition:
      color 0.3s ease,
      background-color 0.3s ease;
  }
  .TabsTrigger:first-child {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
  }
  .TabsTrigger:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  .TabsTrigger:hover {
    background-color: var(--panel-bg-color-hover);
  }
  .TabsTrigger[data-state='active'] {
    color: var(--text-color);
    background-color: var(--panel-bg-color);
  }

  .TabsContent {
    flex-grow: 1;
    outline: none;

    /* border: 1px solid var(--panel-bg-color-hover); */
    border-top: none;
    border-radius: 15px;

    padding: 5px;
  }
`;
